// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IIsPendContributionsOverIrsDto
 */
export interface IIsPendContributionsOverIrsDto {
    /**
     * 
     * @type {boolean}
     * @memberof IIsPendContributionsOverIrsDto
     */
    is_pend_contributions_over_the_irs_max?: boolean;
    /**
     * 
     * @type {string}
     * @memberof IIsPendContributionsOverIrsDto
     */
    is_pend_contributions_over_the_irs_max_state?: IIsPendContributionsOverIrsDtoIsPendContributionsOverTheIrsMaxStateEnum;
}

/**
* @export
* @enum {string}
*/
export enum IIsPendContributionsOverIrsDtoIsPendContributionsOverTheIrsMaxStateEnum {
    MODIFIABLE = 'MODIFIABLE',
    LOCKED = 'LOCKED',
    HIDDEN = 'HIDDEN',
    REQUIRED_AT_PLAN = 'REQUIRED_AT_PLAN',
    REQUIRED_AT_ALL_LEVELS = 'REQUIRED_AT_ALL_LEVELS'
}


/**
 * Check if a given object implements the IIsPendContributionsOverIrsDto interface.
 */
export function instanceOfIIsPendContributionsOverIrsDto(value: object): value is IIsPendContributionsOverIrsDto {
    return true;
}

export function IIsPendContributionsOverIrsDtoFromJSON(json: any): IIsPendContributionsOverIrsDto {
    return IIsPendContributionsOverIrsDtoFromJSONTyped(json, false);
}

export function IIsPendContributionsOverIrsDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IIsPendContributionsOverIrsDto {
    if (json == null) {
        return json;
    }
    return {
        
        'is_pend_contributions_over_the_irs_max': json['is_pend_contributions_over_the_irs_max'] == null ? undefined : json['is_pend_contributions_over_the_irs_max'],
        'is_pend_contributions_over_the_irs_max_state': json['is_pend_contributions_over_the_irs_max_state'] == null ? undefined : json['is_pend_contributions_over_the_irs_max_state'],
    };
}

export function IIsPendContributionsOverIrsDtoToJSON(json: any): IIsPendContributionsOverIrsDto {
    return IIsPendContributionsOverIrsDtoToJSONTyped(json, false);
}

export function IIsPendContributionsOverIrsDtoToJSONTyped(value?: IIsPendContributionsOverIrsDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'is_pend_contributions_over_the_irs_max': value['is_pend_contributions_over_the_irs_max'],
        'is_pend_contributions_over_the_irs_max_state': value['is_pend_contributions_over_the_irs_max_state'],
    };
}

